import { useEffect, useState } from "react";
import axios from "axios";
import { useTitle } from "../components/shared";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const COLUMNS = [
  ["Bride", "bride_name"],
  ["Groom", "groom_name"],
  ["Phone", "phone"],
  ["Alt Phone", "alt_phone"],
  ["Email", "email"],
  ["Based Out Of", "city"],
  ["Wedding Date", "wedding_date"],
  ["Budget Range", "budget_range"],
  ["Wedding Type", "wedding_type"],
  ["Preferred Location", "preferred_location"],
];

export default function Admin() {
  useTitle("Admin | The Big Wedd — Wedding Inquiries");
  const [inquiries, setInquiries] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API}/inquiries`);
      setInquiries(res.data);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    if (!window.confirm("Delete this inquiry?")) return;
    await axios.delete(`${API}/inquiries/${id}`);
    load();
  };

  return (
    <main className="min-h-screen bg-ivory px-6 py-16 md:px-12">
      <div className="mx-auto max-w-7xl">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-[11px] uppercase tracking-[0.3em] text-gold-text">Admin Panel</p>
            <h1 className="mt-2 font-serif text-4xl text-emerald">Wedding Inquiries</h1>
          </div>
          <a href="/" className="text-[11px] uppercase tracking-[0.2em] text-stone2 border-b border-gold pb-1">← Back to site</a>
        </div>

        <p className="mt-4 text-sm text-stone2" data-testid="admin-inquiry-count">
          {loading ? "Loading…" : `${inquiries.length} ${inquiries.length === 1 ? "inquiry" : "inquiries"} received`}
        </p>

        <div className="mt-8 overflow-x-auto border border-gold/25 bg-white/70">
          <table className="w-full text-left text-sm" data-testid="admin-inquiries-table">
            <thead>
              <tr className="border-b border-gold/25 bg-sand/60 text-[10px] uppercase tracking-[0.18em] text-stone2">
                {COLUMNS.map(([h]) => (
                  <th key={h} className="whitespace-nowrap px-4 py-3 font-medium">{h}</th>
                ))}
                <th className="whitespace-nowrap px-4 py-3 font-medium">Events</th>
                <th className="whitespace-nowrap px-4 py-3 font-medium">Add-Ons</th>
                <th className="whitespace-nowrap px-4 py-3 font-medium">Received</th>
                <th className="px-4 py-3" />
              </tr>
            </thead>
            <tbody>
              {inquiries.map((q) => (
                <tr key={q.id} className="border-b border-gold/10 align-top" data-testid={`admin-inquiry-row-${q.id}`}>
                  {COLUMNS.map(([_, key]) => (
                    <td key={key} className="whitespace-nowrap px-4 py-3 text-stone2">
                      <span className={key === "bride_name" ? "font-medium text-emerald" : ""}>{q[key] || "—"}</span>
                    </td>
                  ))}
                  <td className="max-w-40 px-4 py-3 text-xs text-stone2">{(q.events || []).join(", ") || "—"}</td>
                  <td className="max-w-56 px-4 py-3 text-xs text-stone2">
                    {q.event_addons && Object.keys(q.event_addons).length > 0
                      ? Object.entries(q.event_addons).filter(([, v]) => (v || []).length > 0).map(([k, v]) => `${k}: ${v.join(", ")}`).join(" · ") || "—"
                      : "—"}
                  </td>
                  <td className="whitespace-nowrap px-4 py-3 text-xs text-stone2/70">{new Date(q.created_at).toLocaleString()}</td>
                  <td className="px-4 py-3">
                    <button onClick={() => remove(q.id)} data-testid={`admin-delete-${q.id}`} className="text-xs uppercase tracking-[0.15em] text-red-700/70 hover:text-red-700">Delete</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {!loading && inquiries.length === 0 && (
            <p className="px-4 py-10 text-center text-sm text-stone2" data-testid="admin-empty">No inquiries yet — submissions from the Enquire form will appear here.</p>
          )}
        </div>
      </div>
    </main>
  );
}
